/**
 * Store custom event names
 */

/* global $ */


// Events
exports.REVEAL_START = 'revealStart';           // Triggered at the start of a scroll reveal event
exports.REVEAL_COMPLETE = 'revealComplete';     // Triggered at the end of a scroll reveal event
exports.SLIDE_CHANGE = 'slideChange';           // Triggered when hero slider slide changes
exports.REQUEST_SLIDER_PAUSE = 'requestSliderPause';    // More of a reqest than an event -- think command bus
